import MemberSignUpContainer from './MemberSignUpContainer';

export default MemberSignUpContainer;